import Main from './tabbar.vue'
export default Main
